// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Navigator_mainWrapper__jxkQc","actionWrapper":"Navigator_actionWrapper__CMBhb","iconWrapper":"Navigator_iconWrapper__sqmn9","active":"Navigator_active__LG3eG"};